import React, { useState, useEffect, useRef } from 'react'
import { Modal,Button,Col,Row, Tab, Form, Dropdown, FormLabel, FormControl, NavDropdown} from 'react-bootstrap'
import SankeyDraw from 'open-sankey/dist/SankeyDraw'
import parse from 'html-react-parser'
import { AFMSankeyNode,AFMSankeyLink,AFMSankeyData, AFMSankeyNodes, AFMSankeyLinkValue,SankeyData } from './types'
import Menu, { ExempleItem } from 'open-sankey/dist/SankeyMenu'
import {reorganize_all_input_outputLinksId} from 'open-sankey/dist/SankeyLayout'
import { toPrecision,set_nodes_level,getLinkValue,default_link,default_node } from 'open-sankey/dist/SankeyUtils'
import { SankeySettingsEdition } from 'open-sankey/dist/SankeySettingsEdition'
import { SankeySettingsEditionElementTags, SankeySettingsEditionDataTags } from 'open-sankey/dist/SankeySettingsEditionTags'
import * as SankeyUtils from 'open-sankey/dist/SankeyUtils'
import { uploadExcelImpl } from 'open-sankey/dist/SankeyMenu'
import { compute_auto_sankey,compute_default_input_outputLinksId,reorganize_node_inputLinksId,reorganize_node_outputLinksId,updateLayout } from 'open-sankey/dist/SankeyLayout'
import { linkTooltipsContent, nodeTooltipsContent } from './SankeyTooltip'
import { arrangeTrade, split_trade } from './SankeyTrade'
import * as d3 from 'd3'
import SupplyUseModelisationProd from './SankeyReconciliation'
import { useBeforeunload } from 'react-beforeunload'
import LZString from 'lz-string'
//import LZString from 'lz-string'


let logo = ''
try {
  logo = require('../css/mfasankey.jpeg')
} catch (expt) {
  console.log('mfasankey.jpeg not found')
}

type SankeyAppTypes = {
  initial_sankey_data : AFMSankeyData
  exemple_menu        : object
  artefacts_menu      : object
  formations_menu      : object
}

const processExample = (server_data : SankeyData)=> {
  // if (path.includes('v1/filiere_foret_bois_savoie_reconciled.xlsx')) {
  //   server_data.links['link324'].idSource = 'node63'
  //   delete server_data.links['link325']
  // }
  let nb_agregation_level = 0
  Object.values(server_data.nodes).forEach( n => Object.entries(n.dimensions).forEach( dim => nb_agregation_level = dim[1].level as number > nb_agregation_level ? dim[1].level as number : nb_agregation_level))
  set_nodes_level(server_data,server_data.nodes,1)
  if ((server_data as AFMSankeyData & { layout: AFMSankeyData }).layout === undefined) {

    compute_auto_sankey(server_data, server_data.h_space ? server_data.h_space : 200)
    for(let i=nb_agregation_level-1 ; i>=0 ; i--) {
      set_nodes_level(server_data,server_data.nodes,i,false)
    }
  }
  

  if ((server_data as AFMSankeyData & { layout: AFMSankeyData }).layout !== undefined) {
    updateLayout(server_data, (server_data as AFMSankeyData & { layout: AFMSankeyData }).layout)
    // const initial_data = server_data.agregation.level === -1 
    // if ( initial_data ) {
    //   localStorage.setItem('initial_data',LZString.compress(JSON.stringify(server_data)))
    // }
    // let nb_agregation_level = 0
    // Object.values(server_data.nodes).forEach( n => Object.entries(n.dimensions).forEach( dim => nb_agregation_level = dim[1].level as number > nb_agregation_level ? dim[1].level as number : nb_agregation_level))
    // for (let i=1 ; i<=nb_agregation_level ; i++) {
    //   set_nodes_level(server_data,server_data.nodes,i)
    //updateLayout(server_data, (server_data as AFMSankeyData & { layout: AFMSankeyData }).layout)
    //}
    delete (server_data as AFMSankeyData & { layout?: AFMSankeyData }).layout
    // if ( initial_data ) {
    //   Object.assign(server_data,JSON.parse(LZString.decompress(localStorage.getItem('initial_data') as string) as string))
    // }
    // Object.values(server_data.nodes).forEach(n=>{
    //   (n as AFMSankeyNode).trade_close=true
    //   //n.position='relative'
    // })
    // const scale = d3.scaleLinear()
    //   .domain([0, +server_data.user_scale])
    //   .range([0, 100])
    // arrangeTrade(server_data as AFMSankeyData,scale)
    // reorganize_all_input_outputLinksId(server_data.nodes,server_data.links)
  }
  if ((server_data as AFMSankeyData).trade_sectors ) {
    (server_data as AFMSankeyData).trade_sectors.forEach( trade_sector => {
      split_trade(trade_sector, server_data as AFMSankeyData )
    })
  }
  Object.values(server_data.nodes).forEach(n=>{
    (n as AFMSankeyNode).trade_close=true
    //n.position='relative'
  })
  const scale = d3.scaleLinear()
    .domain([0, +server_data.user_scale])
    .range([0, 100])
  arrangeTrade(server_data as AFMSankeyData,scale)
  reorganize_all_input_outputLinksId(server_data.nodes,server_data.links)
  //set_nodes_level(server_data.nodes,1)                   
  // } else {
  //   compute_auto_sankey(server_data, server_data.h_space ? server_data.h_space : 200)
  // }
  return 0
}

declare const window: Window &
typeof globalThis & {
  SankeyToolsStatic: boolean
  sankey: {
    sankey_data_file:RequestInfo
    sous_filieres : { [ key : string ] : string }
    units: string[]
    flask_logo? : string
    flask_header? : string
    logo_width? : number
    legend_average : string
    legend_uncert : string
    help_text : string
    welcome_text: string
    excel : string
    logo: string,
    advanced: boolean
  }
}
const afm_default_node = (initial_sankey_data:AFMSankeyData) : AFMSankeyNode => {
  return {
    ...default_node(initial_sankey_data),
    trade_height : 20,
    trade_width  : 50,
    trade_close  : false,
  }
}

const afm_default_link = (data:AFMSankeyData) : AFMSankeyLink => {
  return {
    ...default_link(data),
    natural_unit : '',
    conv         : [],
    tooltips     : []
  }
}

export const uncert_node_color = () => {
  return 'grey'
}

export const uncert_link_text = (
  data: SankeyData,
  d: AFMSankeyLink,
  link_value: number
) => {
  const link_info = getLinkValue(data,d.idLink) as AFMSankeyLinkValue
  let unit_name = ''
  let the_link_value = toPrecision(link_value)
  if ( data.display_style.unit ) {
    if ( d.natural_unit ) {
      unit_name = d.natural_unit.replace('k tonnes','kt').replace('k tonne','kt')
      the_link_value = toPrecision(link_value * (d.conv ? d.conv[1] : 1) )
    }
  }
  if (link_info.extension.maxi === undefined || link_info.extension.mini === undefined || link_info.extension.maxi === null || link_info.extension.mini === null) {
    return the_link_value + unit_name
  }
  if ( data.display_style.unit && d.conv ) {
    const mini = Math.round(d.conv[1]*link_info.extension.mini)
    const maxi = Math.round(d.conv[1]*link_info.extension.maxi)
    return '['+mini+' '+maxi+']' + ' ' + unit_name
  }

  if (link_info.extension.mini === link_info.extension.maxi) {
    return link_info.extension.mini + ' ' + unit_name
  }

  return '[' + link_info.extension.mini + ' ' + link_info.extension.maxi + ']' + unit_name
}

export const SankeyApp = ({initial_sankey_data,exemple_menu,formations_menu} : SankeyAppTypes) => {
  const [show_split_trade_dialog,set_show_split_trade_dialog] = useState(false)
  const [show_toast, set_show_toast] = useState(false)
  const selected_link = useRef(afm_default_link(initial_sankey_data))
  const selected_node = useRef(afm_default_node(initial_sankey_data))
  const multi_selected_nodes = useRef([])
  const multi_selected_links = useRef([])
  const multi_selected_label = useRef([])
  const button_ref = useRef<HTMLLabelElement>(null)
  const accordion_ref = useRef<HTMLDivElement>(null)
  const links_accordion_ref = useRef<HTMLDivElement>(null)
  const nodes_accordion_ref = useRef<HTMLDivElement>(null)
  const [data,set_data] = useState<AFMSankeyData>(initial_sankey_data)
  const [welcome_text,set_welcome_text] = useState(window.sankey ? window.sankey.welcome_text : '')
  const [trade_width,set_trade_width] = useState(initial_sankey_data.trade_close_hspace)
  const [trade_close,set_trade_close] = useState(true)
  const [agregation_level,set_agregation_level] = useState(0)
  const [show_draw, set_show_draw] = useState(false)
  const [show_reconciliation,set_show_reconciliation] = useState(false)
  const [view, set_view] = useState('none')
  const action_type = useRef('optim_sankey')
  // const [sub_nav_item_active, set_sub_nav_item_active] = useState<string>('')
  const [style_to_apply, set_style_to_apply] = useState('default')
  const [mode_selection, set_mode_selection] = useState('s')

  const {units_names} = data
  let units = undefined
  if (units_names  && units_names.length > 0 && units_names[0].length > 0) {
    units = [units_names[0][0], 'Naturelles']
  }

  useBeforeunload((event : BeforeUnloadEvent) => {
    event.preventDefault()
    localStorage.setItem('data', LZString.compress(JSON.stringify(data)))
  })

  const has_uncert = Object.keys(data.fluxTags).filter(key => key === 'Uncert').length > 0

  const link_text = (
    data: AFMSankeyData,
    d: AFMSankeyLink,
    link_value: number,
    display_style: { font_size?: string; filter?: number; filter_label?: number; unit?: boolean }
  ) => {
    const v = getLinkValue(data,d.idLink)
    const str_display = String(v.display_value)
    if (str_display !== '' && !str_display.includes('[')) {
      if (str_display.includes('[')) {
        return 
      }
      return str_display
    }
    if (data.show_structure) {
      return
    }
    let the_link_value = toPrecision(link_value)
    if (d.colorParameter === 'groupTag' && d.colorTag === 'flux_types' && v.extension.data_value) {
      the_link_value = toPrecision(v.extension.data_value)
    }
    if (display_style.unit && d.conv && d.natural_unit) {
      let unit_coeff = ' '
      if (data.units_names[0][0].includes('k ')) {
        unit_coeff = ' k '
      }
      return toPrecision(the_link_value*d.conv[1]) + unit_coeff + d.natural_unit.replace('tonnes','t').replace('tonne','t').replace('bois rond','')
    } else {
      return the_link_value
    }
  }


  const node_arrow_visible = (n : AFMSankeyNode) => {
    if (!n.node_visible) {
      return false
    }
    if ( n.inputLinksId.length === 0 ) {
      return false
    }
    if (n.trade_close && n.tags['Type de noeud'] !== undefined && n.tags['Type de noeud'][0] == 'échange' && n.inputLinksId.length > 1) {
      return false
    }
    if ( !data.links[n.inputLinksId[0]].arrow ) {
      return false
    }

    return true
  }

  const flux_tags_visible = Object.keys(data.fluxTags).filter(tags_key => tags_key === 'flux_types' || tags_key === 'Uncert' ).length > 0
  const [flux_colormap, set_flux_colormap] = useState('no_colormap')
  const [data_type, set_data_type] = useState('output')

  const scale = d3.scaleLinear()
    .domain([0, +data.user_scale])
    .range([0, 100])
  
  return (
    <div style={{ 'backgroundColor' : 'WhiteSmoke' }}>
      <Menu 
        data={data} 
        set_data={set_data}
        edition_menu = {
          <NavDropdown id='afm' title="AFM" > 
            <Dropdown.Item 
              onClick={ () => {
                if (!('Type de noeud' in data.nodeTags)) {
                  data.nodeTags['Type de noeud'] = {
                    group_name : 'Type de noeud',
                    tags : {
                      'produit' : {
                        name : 'produit',
                        selected : true,
                        color: '',
                        shape: 'ellipse'
                      },
                      'secteur' : {
                        name : 'secteur',
                        selected : true,
                        color: '',
                        shape: 'rect'
                      },
                      'échanges' : {
                        name : 'échanges',
                        selected : true,
                        color: '',
                        shape: 'rect'
                      }
                    },
                    color_map : '',
                    show_legend : false,
                    banner: 'none'
                  }
                  Object.values(data.nodes).forEach(n => n.tags['Type de noeud'] = ['secteur'])
                }                
              }}
            >Création étiquette secteur produit</Dropdown.Item>
            <Dropdown.Item 
              onClick={ () => set_show_split_trade_dialog(true) }
            >Individualiser Import/Export</Dropdown.Item>
            <Dropdown.Item 
              onClick={ () => {
                action_type.current = 'optim_sankey'
                set_show_reconciliation(true) 
              }}
            >Reconciliation (Sankey)</Dropdown.Item>
            <Dropdown.Item 
              onClick={ () => {
                action_type.current = 'optim'
                set_show_reconciliation(true) 
              }}
            >Reconciliation (Excel)</Dropdown.Item>
            <Dropdown.Item 
              onClick={ () => {
                action_type.current = 'check_excel'
                set_show_reconciliation(true) 
              }}
            >Vérification fichier excel</Dropdown.Item>
            <Dropdown.Item 
              onClick={ () => {
                action_type.current = 'create_empty_ter'
                set_show_reconciliation(true) 
              }}
            >Génération de la table emploi ressource</Dropdown.Item>
          </NavDropdown>                        
        }
        url_prefix='/opensankey/'
        logo={!window.SankeyToolsStatic ? logo.replace('static/', 'static/sankeytools/') : window.sankey.logo as string}
        logo_width={!window.SankeyToolsStatic ? 100 : window.sankey.logo_width}       
        app_name={!window.SankeyToolsStatic ? 'preversion 1.0' : ''}
        set_show_toast={set_show_toast}
        show_toast={show_toast}
        mode_selection={mode_selection}
        set_mode_selection={set_mode_selection}
        style_to_apply={style_to_apply}
        set_style_to_apply={set_style_to_apply}
        set_current_filter={(
          new_current_filter: number
        ) => {
          const { display_style } = data
          display_style.filter = +new_current_filter
          set_data({ ...data })
        }}
        right_menu = {<></>}
        formations_menu={<>
          <ExempleItem 
            exemple_menu={formations_menu}
            data={data}
            set_data={set_data}
            current_path={'Formations'}
            url_prefix='/opensankey/'
            multi_selected_links={multi_selected_links}
            multi_selected_nodes={multi_selected_nodes}
            multi_selected_label={multi_selected_label}
            callback={processExample}
          /></>}
        example_menu={<>
          <ExempleItem 
            exemple_menu={exemple_menu}
            data={data}
            set_data={set_data}
            current_path={''}
            url_prefix='/opensankey/'
            multi_selected_links={multi_selected_links}
            multi_selected_nodes={multi_selected_nodes}
            multi_selected_label={multi_selected_label}
            callback={processExample}
          /></>}
        // portfolio_menu={<>
        //   <ArtefactsItem 
        //     artefacts_menu={artefacts_menu}
        //     current_path={''}
        //   /></>}

        selected_node={selected_node}
        multi_selected_nodes={multi_selected_nodes}
        multi_selected_links={multi_selected_links}
        multi_selected_label={multi_selected_label}
        selected_link={selected_link}
        accordion_ref={accordion_ref}
        nodes_accordion_ref={nodes_accordion_ref}
        links_accordion_ref={links_accordion_ref}
        button_ref={button_ref}   
        agregation_level={agregation_level}
        set_agregation_level={set_agregation_level}
        settings_edition= {
          <SankeySettingsEdition
            data={data}
            set_data={set_data}
            set_current_filter={(
              new_current_filter: number
            ) => {
              const { display_style } = data
              display_style.filter = +new_current_filter
              set_data({ ...data })
            }}
          >
            <Tab eventKey="trade" title="Echanges">
              <br></br>
              <Form >
                <Form.Group as={Row} >
                  <Col>
                    <Form.Check  
                      type='checkbox'
                      label='Prés du noeud'
                      checked = {trade_close}
                      onChange = {evt => { 
                        Object.values(data.nodes as AFMSankeyNodes).forEach(n=>n.trade_close = evt.target.checked)
                        set_trade_close(evt.target.checked)
                        set_data({...data}) 
                      }}
                    />
                  </Col>
                  <Col>
                    <Button  onClick={()=> {
                      arrangeTrade(data as AFMSankeyData,scale)
                      set_data({...data})
                    }}>
                      Arranger
                    </Button>
                  </Col>
                </Form.Group>
                <hr/>
                <Form.Group as={Row} >
                  <Col>
                    <FormLabel >Décalage horizontal</FormLabel>
                  </Col>
                  <Col>
                    <Form.Range
                      min="0" max="200"
                      value={data.trade_close_hspace}
                      onChange={
                        evt => {
                          data.trade_close_hspace = +evt.target.value
                          set_data({ ...data })
                        }
                      }
                    />
                  </Col>
                  <Col>{data.trade_close_hspace}</Col>
                </Form.Group>
                <Form.Group as={Row} >
                  <Col>
                    <FormLabel>Décalage vertical</FormLabel>
                  </Col>
                  <Col>
                    <Form.Range
                      min="0" max="200"
                      value={data.trade_close_vspace}
                      onChange={
                        evt => {
                          data.trade_close_vspace = +evt.target.value
                          set_data({ ...data })
                        }
                      }
                    />
                  </Col>
                  <Col>{data.trade_close_vspace}</Col>
                </Form.Group>
                <Form.Group as={Row} >
                  <Col>
                    <FormLabel>Décalage horizontal</FormLabel>
                  </Col>
                  <Col>
                    <Form.Range
                      min="0" max="400"
                      value={data.trade_hspace}
                      onChange={
                        evt => {
                          data.trade_hspace = +evt.target.value
                          set_data({ ...data })
                        }
                      }
                    />
                  </Col>
                  <Col>{data.trade_hspace}</Col>
                </Form.Group>
                <Form.Group as={Row} >
                  <Col>
                    <FormLabel>Position du point de controle source</FormLabel>
                  </Col>
                  <Col>
                    <Form.Range
                      min="0" max="100"
                      value={data.trade_left_shift*100}
                      onChange={
                        evt => {
                          const trade_left_shift = (+evt.target.value)/100
                          if ( trade_left_shift < data.trade_right_shift) {
                            data.trade_left_shift = (+evt.target.value)/100
                          }
                          set_data({ ...data })
                        }
                      }
                    />
                  </Col>
                  <Col>{data.trade_left_shift}</Col>
                </Form.Group>
                <Form.Group as={Row} >
                  <Col>
                    <FormLabel>Position du point de controle destination</FormLabel>
                  </Col>
                  <Col>
                    <Form.Range
                      min="0" max="100"
                      value={data.trade_right_shift*100}
                      onChange={
                        evt => {
                          const trade_right_shift = (+evt.target.value)/100
                          if ( data.trade_left_shift < trade_right_shift) {
                            data.trade_right_shift = (+evt.target.value)/100
                          }
                          set_data({ ...data })
                        }
                      }
                    />
                  </Col>
                  <Col>{data.trade_right_shift}</Col>
                </Form.Group>
                <Form.Group as={Row} >
                  <Col>
                    <FormLabel>Ecart maximum entre points de controle</FormLabel>
                  </Col>
                  <Col>
                    <Form.Range
                      min="0" max="50"
                      value={data.trade_max_shift*100}
                      onChange={
                        evt => {
                          data.trade_max_shift = (+evt.target.value)/100
                          set_data({ ...data })
                        }
                      }
                    />
                  </Col>
                  <Col>{data.trade_max_shift}</Col>
                </Form.Group>
              </Form>
            </Tab>
          </SankeySettingsEdition>
        }
        node_edition= {
          <Tab eventKey="exchanges" title="Echanges">
            <br></br>
            <Form >
              <Form.Group as={Row} >
                <Col>
                  <Form.Check  
                    type='checkbox'
                    label='Prés du noeud'
                    checked = {selected_node.current.trade_close }
                    onChange = {evt => { 
                      selected_node.current.trade_close = evt.target.checked
                      set_data({...data}) 
                    }}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row} >
                <Col>
                  <FormLabel >Width</FormLabel>
                </Col>
                <Col>
                  <FormControl
                    type="text"
                    value={selected_node.current.trade_width}
                    onChange={evt => set_trade_width(+evt.target.value)}
                    onBlur={() => {
                      selected_node.current.trade_width = trade_width
                      set_data({ ...data })
                    }}
                  />
                </Col>
              </Form.Group>
            </Form>
          </Tab>
        }
        link_edition={null}
        settings_edition_node_tags={
          <SankeySettingsEditionElementTags
            data={data}
            set_data={set_data}
            elementTagNameProp='nodeTags'
            elementNameProp='nodes'
          />
        }
        settings_edition_link_tags={
          <SankeySettingsEditionElementTags
            data={data}
            set_data={set_data}
            elementTagNameProp='fluxTags'
            elementNameProp='links'
          />
        }
        settings_edition_data_tags={
          <SankeySettingsEditionDataTags
            data={data}
            set_data={set_data}
          />
        }
        view={view}
        set_view={set_view}
        additional_selector={<Col>
          <Form.Group as={Row} style={{width: '400px', alignItems: 'baseline', }}>
            { Array.isArray(units) ? (<Col>
              <FormLabel style={{justifyContent: 'center'}} ><b>Unités</b></FormLabel>
              <Form.Select 
                style={{ color:'black' }}
                value={data.display_style.unit ? 'Naturelles' : units.filter(unit=>unit!=='Naturelle')[0]}
                onChange={ evt=> {
                  const unit = evt.target.value
                  data.display_style.unit = unit === 'Naturelles'
                  set_data({...data})
                }}>
                {units.map( 
                  (name,i) => 
                    <option key={i} value={name}>{name}</option>)}
              </Form.Select></Col>
            ) : (<Col></Col>)
            }
            { flux_tags_visible ? (<Col>
              <FormLabel style={{justifyContent: 'center'}} ><b>Valeurs Visualisées</b></FormLabel>
              <Form.Select
                disabled={false}
                onChange={
                  (evt: React.ChangeEvent<HTMLSelectElement>) => {
                    Object.values(data.links).forEach(el => {
                      el.colorParameter = 'groupTag'
                      el.colorTag = evt.target.value === 'input' ? 'flux_types' : 'no_colormap'
                    })
                    Object.values(data.fluxTags).forEach(tags_group => tags_group.show_legend = false)
                    if (evt.target.value === 'input') {
                      set_flux_colormap('flux_types')
                      data.fluxTags.flux_types.show_legend = true
                    }
                    set_data_type(evt.target.value)
                    set_data({ ...data })
                  }}>
                <option
                  key='input'
                  value={'input'}
                  selected={data_type === 'input'} >
                      Données d'entrée
                </option>
                <option
                  key='output'
                  value={'output'}
                  selected={data_type === 'output'} >
                      Données en sortie
                </option>
              </Form.Select>
              {has_uncert ? (
                <Form.Select
                  style={{ opacity: data_type === 'input' ? '0.3' : 1, marginTop:'10px' }}
                  disabled={data_type === 'input'}
                  onChange={
                    (evt: React.ChangeEvent<HTMLSelectElement>) => {
                      Object.values(data.links).forEach(el => {
                        el.colorParameter = 'groupTag'
                        el.colorTag = evt.target.value
                      })
                      //set_flux_colormap(evt.target.value)
                      Object.values(data.fluxTags).forEach(tags_group => tags_group.show_legend = false)
                      if (evt.target.value !== 'no_colormap') {
                        data.fluxTags[evt.target.value].show_legend = true
                      }
                      set_data({ ...data })
                    }}>

                  <option
                    key='no_colormap'
                    value={'no_colormap'}
                    selected={flux_colormap === 'no_colormap'} >
                        Données moyennes
                  </option>
                  {Object.entries(data.fluxTags).filter(([key,]) => key === 'Uncert' ).map(
                    (tags_group, i) =>
                      <option
                        key={i}
                        value={tags_group[0]}
                        selected={flux_colormap === tags_group[0]} >
                        {tags_group[1].group_name}
                      </option>)}
                </Form.Select>) : (<></>)}
            </Col>) : (<Col></Col>)}
          </Form.Group></Col>
        }
      />
      {//Ajout d'un delay pour laisser le temps au Menu de render pour ensuite utiliser sa hauteur afin d'ajouter un margin top au draw
      }
      {useEffect(() => {
        const timer = setTimeout(() => {
          set_show_draw(true)
        }, 100)
        return () => clearTimeout(timer)
      }, [])}
      {
        (show_draw && view=='none') ? (<SankeyDraw
          data={data}
          set_data={set_data}
          multi_selected_nodes={multi_selected_nodes}
          multi_selected_label={multi_selected_label}
          multi_selected_links={multi_selected_links}
          accordion_ref={accordion_ref}
          nodes_accordion_ref={nodes_accordion_ref}
          links_accordion_ref={links_accordion_ref}
          button_ref={button_ref}   
          select_node={(n: AFMSankeyNode) => {
            selected_node.current = n
          }}
          //node_visible={(n : SankeyNode) => node_or_label_visible(n) && n.visible ? 'visible' : 'hidden'}
          //node_label_visible={(n : SankeyNode) => node_or_label_visible(n) && n.label_visible ? 'visible' : 'hidden'}
          node_arrow_visible={node_arrow_visible}

          select_link={(l: AFMSankeyLink) => {
            selected_link.current = l
          }}
          link_text = {flux_colormap === 'Uncert' ? uncert_link_text : link_text }
          test_link_value={SankeyUtils.test_link_value}
          nodeTooltipsContent={nodeTooltipsContent}
          linkTooltipsContent={linkTooltipsContent}
          set_show_toast={set_show_toast}
          mode_selection={mode_selection}
          set_mode_selection={set_mode_selection}
          current={true}
        // set_selected_id_link={set_selected_id_link}
        // selected_id_link={selected_id_link}
        />) : (<></>)}
      <Modal 
        bsSize="large" 
        show={welcome_text !== undefined && welcome_text !== ''} 
        onHide={()=>{
          set_welcome_text('')
        }}
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
        <Modal.Header closeButton>
          <Modal.Title>Lisez Moi</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {welcome_text ? parse(welcome_text) : ''}
          <Button 
            onClick={()=>{
              set_welcome_text('')
            }}
          >J&apos;ai lu</Button>
        </Modal.Body>
      </Modal>
      { show_split_trade_dialog ?  (
        <SplitVerticalModal 
          data = {data}
          initial_trade_node_names = {(data as AFMSankeyData).trade_sectors ? (data as AFMSankeyData).trade_sectors : [] }
          set_show_split_trade = {set_show_split_trade_dialog} />
      ) :
        (<div/>)
      }
      {show_reconciliation ? (
        <SupplyUseModelisationProd
          show_reconciliation={true}
          action_type={action_type}
          set_show_reconciliation={set_show_reconciliation}
          uploadExcelImpl={uploadExcelImpl}
          sankey_data={data}
          set_sankey_data={set_data} />
      ) :
        (<div />)
      }
    </div>
  )
}

export default SankeyApp

export const computeTotalOffsets = (
  data: AFMSankeyData,
  node: AFMSankeyNode,
  nodes: { [idNode:string]:AFMSankeyNode},
  links: { [idLink:string]:AFMSankeyLink}
) =>{
  let total_output_offset = 0
  node.outputLinksId.forEach(
    (idLink) => {
      const link = links[idLink]
      if ( !nodes[link.idSource].node_visible || !nodes[link.idTarget].node_visible ) {
        return
      }
      //if (data_displayed && link.tags['flux_types'].includes('initial_data') && link.data_value !== undefined && link.data_value !== null ) {
      total_output_offset += getLinkValue(data,link.idLink).value
      // } else {
      //   total_output_offset += getLinkValue(data,link.idLink).value
      // }
    }
  )
  let total_input_offset = 0
  node.inputLinksId.forEach(
    (idLink) => {
      const link = links[idLink]
      if ( !nodes[link.idSource].node_visible || !nodes[link.idTarget].node_visible ) {
        return
      }
      //if (data_displayed && link.tags['flux_types'].includes('initial_data') && link.data_value !== undefined && link.data_value !== null ) {
      total_input_offset += getLinkValue(data,link.idLink).value
      //} else {
      //  total_input_offset += getLinkValue(data,link.idLink)         
      //}
    }
  )
  return [total_input_offset,total_output_offset]
}

const SplitVerticalModalPropTypes = {

}

// type  SplitVerticalModalTypes = {
//   data : AFMSankeyData,
//   initial_trade_node_names : string[],
//   set_show_split_trade : (show:boolean) => void
// }

const SplitVerticalModal = (
  {data,initial_trade_node_names,set_show_split_trade} : {data : AFMSankeyData,initial_trade_node_names : string[] ,set_show_split_trade:(show:boolean)=>void}
) => {
  const [trade_node_names,set_trade_node_names] = useState(initial_trade_node_names)

  return (
    <Modal 
      show={true} 
      onHide={ () => set_show_split_trade(false) } >
      <Modal.Header closeButton>
        <Modal.Title>Noeuds Imports Exports</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group>
            <Row>
              <Col>    
                <Form.Select multiple
                  onChange={evt=> {
                    const new_trade_nodes = []
                    for (let i=0;i<(evt.currentTarget as HTMLSelectElement).options.length;i++) {
                      if ( (evt.currentTarget as HTMLSelectElement).options[i].selected ) {
                        new_trade_nodes.push((evt.currentTarget as HTMLSelectElement).options[i].label)
                      }
                    }
                    data.trade_sectors = new_trade_nodes
                    set_trade_node_names(new_trade_nodes)
                  }}
                >
                  {Object.values(data.nodes).filter(
                    n => n.tags['Type de noeud'] && n.tags['Type de noeud'][0] == 'échange' && n.name.split('-').length === 2
                  ).map(
                    (n, i) => <option key={i} value={n.name} selected={trade_node_names.includes(n.name)} >{n.name}</option>
                  )}
                </Form.Select>
              </Col>
            </Row>      
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button 
          variant="secondary" 
          onClick={()=> {
            data.trade_sectors.forEach(trade_sector=>split_trade(trade_sector,data))
            compute_default_input_outputLinksId(data.nodes,data.links)
            Object.values(data.nodes).forEach(function (n) {
              reorganize_node_inputLinksId(n, data.nodes, data.links)
              reorganize_node_outputLinksId(n, data.nodes, data.links)
            })
            set_show_split_trade(false)
          }}
        >Individualiser</Button>
        <Button variant="secondary" onClick={() => set_show_split_trade(false)}>Annuler</Button>
      </Modal.Footer>
    </Modal>)
}

SplitVerticalModal.propTypes = SplitVerticalModalPropTypes


